import React, { useState } from 'react'
import Modal from '@/v2/components/common/Modal'
import { useSnackbarContext } from '@/v2/contexts/SnackbarContext'
import { useAddInsurance } from '@/v2/hooks/insurance/useInsurances'
import Form from './insurance-form/Form'
import { validateInsurance } from './insurance-form/validator'
import useModals from '@/v2/hooks/useModals'
import useDetectDevice from '@/v2/hooks/useDetectDevice'

const InsuranceForm = ({
  patient,
  modalType,
  insurance = {},
  isOpen,
  onClose,
}) => {
  const [values, setValues] = useState({
    groupNumber: insurance.groupNumber || '',
    payerId: '',
    relationship: insurance.relationship || '',
    memberId: insurance.memberId || '',
    payer: insurance?.payer?.name || '',
  })
  const [error, setError] = useState({})
  const { addInsurance } = useAddInsurance(patient.id)
  const { onOpenSnackbar } = useSnackbarContext()
  const { goTo } = useModals()
  const { isMobile } = useDetectDevice()

  const handleAddInsurance = async () => {
    const body = {
      insurance: {
        ...values,
      },
    }
    try {
      const res = await addInsurance(body)
      if (!res.error) {
        onOpenSnackbar('Insurance added', 'success')
        onClose()
        goTo(`/v2/patient/${patient.id}/insurance/view`, {
          modalType: 'view',
          insurance: res,
          patient,
        })
      }
    } catch (error) {
      console.error('error', error)
      onOpenSnackbar(`${error}`, 'error')
    }
  }

  const handleSubmit = async () => {
    if (modalType !== 'view') {
      const validErrors = await validateInsurance(values)
      setError(validErrors || {})
      if (!validErrors) {
        handleAddInsurance()
      }
      return
    }

    goTo(`/v2/patient/${patient.id}/eligibility/check`, {
      modalType: 'create',
      patient,
      insurance: insurance || values,
    })
  }

  return (
    <Modal
      isOpen={isOpen}
      title="Add Insurance"
      showConfirm={modalType !== 'view'}
      confirmLabel={'Add'}
      cancelLabel={modalType === 'view' ? 'Close' : 'Cancel'}
      onConfirm={handleSubmit}
      onClose={onClose}
      fullScreen={isMobile}
      fixedHeight={isMobile ? undefined : '45vh'}
      showClose={modalType !== 'view'}
    >
      <Form
        values={values}
        error={error}
        disableFields={modalType === 'view'}
        onChange={value => setValues({ ...values, ...value })}
      />
    </Modal>
  )
}

export default InsuranceForm
